import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { BuyerAuthService } from '../services/buyer-auth/buyer-auth.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { isPlatformBrowser } from '@angular/common';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { PreviousRouteService } from 'src/app/Shared/services/previous-route/previous-route.service';
import { getQueryString } from 'src/app/_utlis/convert-url';

@Injectable({
  providedIn: 'root',
})
export class BuyerLoginCheckGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: BuyerAuthService,
    private storage: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private nav: Navigation,
    private previousRouteService: PreviousRouteService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isBrowser = isPlatformBrowser(this.platformId);
    this.setSEOData(route);
    if (this.authService.isLoggedInAndAuthorized()) {
      if (isBrowser) {
        const previousUrl = this.previousRouteService.getPreviousUrl();
        // Redirect to previous URL if it exists and belongs to the buyer module
        if (previousUrl && previousUrl.includes('/buyer')) {
          const { path, queryObject } = getQueryString(previousUrl);
          this.router.navigate([path], { queryParams: queryObject });
        } else {
          this.nav.NavigateToLanding();
        }
      }
      return false; // Prevent access to the login route
    }

    return true;
  }
  private setSEOData(route: ActivatedRouteSnapshot): void {
    // Get the deepest child route data for the most specific SEO information
    let currentRoute: ActivatedRouteSnapshot | null = route;
    let seoData: any = {};

    // Traverse the route tree to get the most specific data
    while (currentRoute) {
      if (currentRoute.data) {
        seoData = { ...seoData, ...currentRoute.data };
      }
      currentRoute = currentRoute.firstChild || null;
    }

    // Set page title
    const pageTitle = seoData['title'] || 'BidxSell - Horse Auction Platform';
    this.titleService.setTitle(pageTitle);

    // Set meta description
    const description =
      seoData['description'] ||
      'Join BidxSell for premium horse auctions and bidding opportunities.';
    this.metaService.updateTag({
      name: 'description',
      content: description,
    });
  }
}
